// Catálogos MAESTROS del sistema (mirror de /app/backend/catalogos_maestros.py).
// Si actualizas uno, actualiza el otro para que backend y frontend queden en sincronía.

// 32 entidades federativas (INEGI).
export const ESTADOS_MX = [
  "Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas",
  "Chihuahua", "Ciudad de México", "Coahuila", "Colima", "Durango", "Estado de México",
  "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit",
  "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí",
  "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas",
];

// Catálogo curado de actividades económicas. `av = true` = Actividad Vulnerable Art. 17 LFPIORPI.
export const ACTIVIDADES_ECONOMICAS = [
  // COMERCIO
  { value: "Abarrotes/tienda de conveniencia", grupo: "Comercio" },
  { value: "Comercio al por mayor", grupo: "Comercio" },
  { value: "Comercio al por menor", grupo: "Comercio" },
  { value: "Ferretería y materiales", grupo: "Comercio" },
  { value: "Farmacia", grupo: "Comercio" },
  { value: "Papelería", grupo: "Comercio" },
  { value: "Ropa y calzado", grupo: "Comercio" },
  { value: "Mueblería", grupo: "Comercio" },
  { value: "Comercio de vehículos", grupo: "Comercio", av: true },
  { value: "Joyería y relojería", grupo: "Comercio", av: true },
  { value: "Compraventa de arte y antigüedades", grupo: "Comercio", av: true },
  // SERVICIOS
  { value: "Restaurante y alimentos", grupo: "Servicios" },
  { value: "Hotelería y hospedaje", grupo: "Servicios" },
  { value: "Salón de belleza/estética", grupo: "Servicios" },
  { value: "Taller mecánico", grupo: "Servicios" },
  { value: "Lavandería", grupo: "Servicios" },
  { value: "Consultoría", grupo: "Servicios" },
  { value: "Publicidad y marketing", grupo: "Servicios" },
  { value: "Tecnología y software", grupo: "Servicios" },
  { value: "Seguridad privada", grupo: "Servicios" },
  { value: "Traslado de valores", grupo: "Servicios", av: true },
  { value: "Blindaje", grupo: "Servicios", av: true },
  // SERVICIOS PROFESIONALES
  { value: "Despacho contable", grupo: "Servicios profesionales" },
  { value: "Despacho jurídico", grupo: "Servicios profesionales" },
  { value: "Notaría/correduría", grupo: "Servicios profesionales", av: true },
  { value: "Servicios médicos", grupo: "Servicios profesionales" },
  { value: "Arquitectura e ingeniería", grupo: "Servicios profesionales" },
  { value: "Agencia aduanal", grupo: "Servicios profesionales", av: true },
  // CONSTRUCCIÓN E INMOBILIARIO
  { value: "Construcción de obra", grupo: "Construcción e inmobiliario" },
  { value: "Desarrollo inmobiliario", grupo: "Construcción e inmobiliario", av: true },
  { value: "Compraventa de inmuebles", grupo: "Construcción e inmobiliario", av: true },
  { value: "Arrendamiento de inmuebles", grupo: "Construcción e inmobiliario", av: true },
  { value: "Inmobiliaria/intermediación", grupo: "Construcción e inmobiliario", av: true },
  // INDUSTRIA
  { value: "Manufactura/fábrica", grupo: "Industria" },
  { value: "Alimentos y bebidas (producción)", grupo: "Industria" },
  { value: "Textil", grupo: "Industria" },
  { value: "Metalmecánica", grupo: "Industria" },
  { value: "Imprenta", grupo: "Industria" },
  { value: "Reciclaje", grupo: "Industria" },
  // SECTOR PRIMARIO
  { value: "Agricultura", grupo: "Sector primario" },
  { value: "Ganadería", grupo: "Sector primario" },
  { value: "Pesca", grupo: "Sector primario" },
  { value: "Silvicultura", grupo: "Sector primario" },
  { value: "Minería", grupo: "Sector primario" },
  // TRANSPORTE
  { value: "Transporte de carga", grupo: "Transporte" },
  { value: "Transporte de pasajeros", grupo: "Transporte" },
  { value: "Mensajería y paquetería", grupo: "Transporte" },
  { value: "Almacenaje", grupo: "Transporte" },
  // FINANCIERO
  { value: "Casa de cambio", grupo: "Financiero", av: true },
  { value: "Centro cambiario", grupo: "Financiero", av: true },
  { value: "Transmisor de dinero", grupo: "Financiero", av: true },
  { value: "Otorgamiento de crédito/SOFOM", grupo: "Financiero", av: true },
  { value: "Casa de empeño", grupo: "Financiero", av: true },
  { value: "Emisión de tarjetas/vales", grupo: "Financiero", av: true },
  { value: "Activos virtuales/cripto", grupo: "Financiero", av: true },
  // ENTRETENIMIENTO
  { value: "Casino/juegos con apuesta", grupo: "Entretenimiento", av: true },
  { value: "Sorteos y loterías", grupo: "Entretenimiento", av: true },
  { value: "Eventos y espectáculos", grupo: "Entretenimiento" },
  // OTROS
  { value: "Asociación civil/donataria", grupo: "Otros", av: true },
  { value: "Educación/escuela", grupo: "Otros" },
  { value: "Actividad agropecuaria diversa", grupo: "Otros" },
  { value: "Empleado/asalariado (PF sin actividad empresarial)", grupo: "Otros" },
  { value: "Otro (especificar)", grupo: "Otros" },
];

// Índice rápido: es la lista de labels vulnerables (usada por la UI para pintar la etiqueta [AV]).
export const ACTIVIDADES_VULNERABLES = new Set(
  ACTIVIDADES_ECONOMICAS.filter((a) => a.av).map((a) => a.value)
);

// Grupos únicos (para agrupar en el selector).
export const ACTIVIDADES_GRUPOS = Array.from(
  new Set(ACTIVIDADES_ECONOMICAS.map((a) => a.grupo))
);


// =============================================================================
// TIPOS DE PERSONA — lista cerrada única (mirror del backend).
// `key` = clave interna guardada en DB; `label` = string mostrado en la UI.
// =============================================================================
export const TIPOS_PERSONA = [
  { key: "fisica_nacional", label: "Personas físicas nacionales", categoria: "fisica", esPm: false },
  { key: "fisica_extranjera", label: "Personas físicas extranjeras", categoria: "fisica", esPm: false },
  { key: "moral_nacional", label: "Personas morales nacionales", categoria: "moral", esPm: true },
  { key: "moral_extranjera", label: "Personas morales extranjeras", categoria: "moral", esPm: true },
  { key: "fideicomiso", label: "Fideicomisos", categoria: "fideicomiso", esPm: true },
];

// Índices rápidos para lookup.
export const TIPOS_PERSONA_LABEL = Object.fromEntries(TIPOS_PERSONA.map((t) => [t.key, t.label]));
export const TIPOS_PERSONA_KEYS = TIPOS_PERSONA.map((t) => t.key);

/** Convierte cualquier valor (nueva clave o string legacy) a la etiqueta legible.
 *  Se usa en tablas y badges para no romper con clientes viejos que aún tienen "Persona física". */
export function labelTipoPersona(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (TIPOS_PERSONA_LABEL[s]) return TIPOS_PERSONA_LABEL[s];
  const lo = s.toLowerCase();
  if (lo.includes("fideicomiso")) return TIPOS_PERSONA_LABEL.fideicomiso;
  const esMoral = lo.includes("moral");
  const esExtranj = lo.includes("extranj");
  if (esMoral) return esExtranj ? TIPOS_PERSONA_LABEL.moral_extranjera : TIPOS_PERSONA_LABEL.moral_nacional;
  if (esExtranj && (lo.includes("fisica") || lo.includes("física"))) return TIPOS_PERSONA_LABEL.fisica_extranjera;
  if (lo.includes("dependencia") || lo.includes("gobierno") || lo.includes("gubernamental")) {
    return TIPOS_PERSONA_LABEL.moral_nacional;
  }
  return s; // devuelve string original si no se reconoce (para no romper visualmente)
}

// =============================================================================
// DESTINOS DE CRÉDITO — lista maestra (mirror del backend).
// =============================================================================
export const DESTINOS_CREDITO = [
  { key: "capital_trabajo", label: "Capital de trabajo" },
  { key: "adquisicion_equipo", label: "Adquisición de equipo / maquinaria" },
  { key: "adquisicion_inventario", label: "Adquisición de inventario / mercancía" },
  { key: "adquisicion_vehiculo", label: "Adquisición de vehículo" },
  { key: "adquisicion_inmueble", label: "Adquisición de inmueble" },
  { key: "construccion_remodelacion", label: "Construcción / remodelación" },
  { key: "consolidacion_deuda", label: "Consolidación / pago de deuda" },
  { key: "expansion_negocio", label: "Expansión del negocio" },
  { key: "gastos_operacion", label: "Gastos de operación / nómina" },
  { key: "activos_virtuales", label: "Activos virtuales / criptomonedas" },
  { key: "otros_gastos_personales", label: "Gastos personales" },
  { key: "no_especificado", label: "No especificado" },
];
const DESTINOS_CREDITO_LABEL = Object.fromEntries(DESTINOS_CREDITO.map((d) => [d.key, d.label]));

export function labelDestinoCredito(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (DESTINOS_CREDITO_LABEL[s]) return DESTINOS_CREDITO_LABEL[s];
  return s; // legacy string, se muestra tal cual
}

// =============================================================================
// FUENTES DE PAGO — lista maestra.
// =============================================================================
export const FUENTES_PAGO = [
  { key: "ingresos_negocio", label: "Ingresos del negocio / actividad empresarial" },
  { key: "salario", label: "Salario / nómina" },
  { key: "honorarios", label: "Honorarios profesionales" },
  { key: "rentas", label: "Rentas de inmuebles" },
  { key: "dividendos", label: "Dividendos / rendimientos financieros" },
  { key: "pension", label: "Pensión / jubilación" },
  { key: "remesas", label: "Remesas" },
  { key: "ventas_terceros", label: "Ventas a terceros" },
  { key: "otros_ingresos", label: "Otros ingresos comprobables" },
];
const FUENTES_PAGO_LABEL = Object.fromEntries(FUENTES_PAGO.map((f) => [f.key, f.label]));

export function labelFuentePago(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (FUENTES_PAGO_LABEL[s]) return FUENTES_PAGO_LABEL[s];
  return s;
}

// =============================================================================
// MEDIOS DE PAGO — lista maestra ÚNICA. `dispersion` marca los que se usan
// también como medio de dispersión de créditos.
// =============================================================================
export const MEDIOS_PAGO = [
  { key: "efectivo", label: "Efectivo", dispersion: true, cobranza: true },
  { key: "transferencia", label: "Transferencia (SPEI)", dispersion: true, cobranza: true },
  { key: "cheque", label: "Cheque", dispersion: true, cobranza: true },
  { key: "tarjeta", label: "Tarjeta débito / crédito", dispersion: false, cobranza: true },
  { key: "domiciliacion", label: "Domiciliación", dispersion: false, cobranza: true },
];
const MEDIOS_PAGO_LABEL = Object.fromEntries(MEDIOS_PAGO.map((m) => [m.key, m.label]));
export const MEDIOS_DISPERSION = MEDIOS_PAGO.filter((m) => m.dispersion);

export function labelMedioPago(raw) {
  if (!raw) return "";
  const s = String(raw).trim();
  if (MEDIOS_PAGO_LABEL[s]) return MEDIOS_PAGO_LABEL[s];
  return s;
}


// ─────────────────────────────────────────────────────────────────────────────
// PLAZOS Y PERIODICIDADES DE PRODUCTOS DE CRÉDITO (fuente única — espeja backend)
// ─────────────────────────────────────────────────────────────────────────────
// Rango permitido de plazos (número de pagos). El producto elige un SUBCONJUNTO.
// Backend: `/app/backend/catalogos_maestros.py::PLAZOS_PERMITIDOS_RANGO`.
export const PLAZOS_MIN = 4;
export const PLAZOS_MAX = 60;
export const PLAZOS_PERMITIDOS_RANGO = Array.from(
  { length: PLAZOS_MAX - PLAZOS_MIN + 1 },
  (_, i) => PLAZOS_MIN + i
); // [4, 5, ..., 60]

// Periodicidades permitidas para NUEVOS productos: solo 3.
// (El motor de amortización sigue soportando legacy Diaria/Catorcenal/Bimestral/Trimestral
// solo para créditos ya emitidos, pero productos nuevos SOLO estas 3.)
export const PERIODICIDADES_PRODUCTO = [
  { value: "Semanal", label: "Semanal", factor_ppa: 52, dias: 7 },
  { value: "Quincenal", label: "Quincenal", factor_ppa: 24, dias: 15 },
  { value: "Mensual", label: "Mensual", factor_ppa: 12, dias: 30 },
];
export const PERIODICIDADES_PRODUCTO_KEYS = PERIODICIDADES_PRODUCTO.map((p) => p.value);
